import { useTranslation } from "react-i18next";

/**
 * Helper bilingüe para textos que aún no están en los archivos de i18n.
 * Devuelve una función L(es, en) que elige según el idioma activo.
 *
 *   const L = useLang();
 *   <h1>{L("Hola", "Hello")}</h1>
 *
 * Usar useTranslation() internamente asegura el re-render al cambiar idioma.
 */
export function useLang() {
  const { i18n } = useTranslation();
  return (es, en) => (i18n.language === "en" ? en : es);
}
